export const HERO_VIDEO = "https://egmg.ae/wp-content/uploads/2026/01/Egmg-Main-Video-2.mp4";
export const HERO_POSTER = "/generated/home-hero-skyline.jpg";

export const STATS = [
  { value: "50", suffix: "years", label: "Moving the UAE since 1976" },
  { value: "12,000+", label: "Vehicles across the group fleet" },
  { value: "1,200+", label: "Mobility professionals" },
  { value: "14", label: "Locations across the UAE" },
];

export const PATHS = {
  personal: {
    chip: "For You",
    title: "Personal mobility, made simple.",
    desc: "Rent for a day or a month, book a chauffeur in minutes, or drive away in a certified pre-owned car. One group, every option.",
    img: "/generated/personal-keys-handover.jpg",
    cta: { label: "Explore personal services", href: "/services#personal" },
    chips: [
      { label: "Rent a Car", href: "/europcar" },
      { label: "Book a Chauffeur", href: "/book-chauffeur" },
      { label: "Airport Transfers", href: "/chauffeur-service" },
      { label: "Monthly Rental", href: "/monthly-car-rental-dubai" },
      { label: "Pre-Owned Cars", href: "/used-cars" },
    ],
  },
  business: {
    chip: "For Business",
    title: "Fleet solutions that keep your business moving.",
    desc: "Operational leasing, staff transport, coaches, commercial vehicles and managed fleets, backed by ISO-certified workshops and 24/7 support.",
    img: "/generated/leasing-fleet-corporate.jpg",
    cta: { label: "Explore business solutions", href: "/services" },
    chips: [
      { label: "Operational Leasing", href: "/leasing" },
      { label: "Staff Transport", href: "/royal-limousine" },
      { label: "Fleet Management", href: "/dubai-municipality" },
      { label: "Commercial Vehicles", href: "/truckline" },
      { label: "Events & VIP", href: "/chauffeur-service" },
    ],
  },
};

export const STEPS = [
  { num: "01", title: "Tell us what you need", desc: "Choose a service or send a quick quote request. Personal or business, one form covers it." },
  { num: "02", title: "Get a tailored proposal", desc: "Our specialists confirm vehicles, routes or lease terms, usually within one working day." },
  { num: "03", title: "We handle the details", desc: "Delivery, drivers, insurance, maintenance and telematics are all managed by the group." },
  { num: "04", title: "You keep moving", desc: "24/7 support, replacement vehicles and a single point of contact for the life of the contract." },
];

export const WHY = [
  { title: "Commitment to Quality", desc: "ISO 9001:2015 and ISO 10002 certified processes, A-grade workshops and a fleet renewed on strict cycles." },
  { title: "Transparency & Reliability", desc: "Clear pricing, honest timelines and 50 years of keeping promises to families, airlines and government partners." },
  { title: "24/7 Seamless Support", desc: "Round-the-clock control room, roadside recovery and a toll-free line: 800 364, whenever you need us." },
  { title: "All Seven Emirates", desc: "One of very few operators licensed for chauffeur and coach services across the entire UAE." },
];

export const CLIENTS = [
  { name: "Emirates", url: "/partners/emirates-logo.svg" },
  { name: "ADNOC", url: "/partners/adnoc-logo.svg" },
  { name: "DP World", url: "/partners/dpworld-logo.svg" },
  { name: "Dubai Holding", url: "/partners/dubai-holding-logo.svg" },
  { name: "Al Khoory Automobiles", url: "/partners/al-khoory-logo.svg" },
  { name: "IMT Dubai", url: "/partners/imt-dubai-logo.svg" },
  { name: "Europcar", url: "/europcar-logo.png" },
];

export const AWARDS = [
  "Car Rental Global Award, Best Performance 2023",
  "Best Car Rental Company in the Middle East",
  "ISO 9001:2015 · ISO 10002:2014",
  "Emirates Group Recognition, Crew Transportation",
];
